import { render, staticRenderFns } from "./confirmCost.vue?vue&type=template&id=4066b55c&scoped=true&"
import script from "./confirmCost.vue?vue&type=script&lang=js&"
export * from "./confirmCost.vue?vue&type=script&lang=js&"
import style0 from "./confirmCost.vue?vue&type=style&index=0&id=4066b55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066b55c",
  null
  
)

export default component.exports